import React from 'react';
import { CoinsIcon, FileTextIcon, HomeIcon, TreesIcon } from 'lucide-react';
import { benefits } from '../data/site';
const icons: Record<string, React.ComponentType<{
  size?: number;
  strokeWidth?: number;
}>> = {
  trees: TreesIcon,
  file: FileTextIcon,
  coins: CoinsIcon,
  home: HomeIcon
};
export function BenefitsBar() {
  return <section aria-label="Beneficios" className="bg-gold" data-id="element-23" data-mp="1noqwj3nszaea">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-7 px-5 py-8 lg:grid-cols-4 lg:px-8" data-id="element-24" data-mp="qzji0fllq1jv">
        {benefits.map(benefit => {
        const Icon = icons[benefit.icon];
        return <div key={benefit.title} className="flex items-start gap-3 text-white" data-id="element-25" data-mp="zyn3trc5kv22">
              <Icon size={26} strokeWidth={1.6} data-id="element-26" data-mp="14qy5ozqgeqx9" />
              <div data-id="element-27" data-mp="14rpotb2v6w6n">
                <p className="text-[13px] font-semibold uppercase tracking-[0.1em]" data-id="element-28" data-mp="14s940k14r6gz">
                  {benefit.title}
                </p>
                <p className="mt-0.5 text-[13px] text-white/85" data-id="element-29" data-mp="c9c2a7mzawmv">{benefit.detail}</p>
              </div>
            </div>;
      })}
      </div>
    </section>;
}